import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import { headApi } from "utils/headApi";
import { localApi } from "utils/imgApi";
import Check from "@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import style from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleSweet = makeStyles(styleSweet);

export default function AddPacking(props) {
  const [dibbiName, setDibbiName] = React.useState("");
  const [hsncode, setHsncode] = React.useState("");
  const [price, setPrice] = React.useState("");
  const [gst, setGst] = React.useState("");
  const [dibbiErr, setDibbiErr] = React.useState("");
  const [hsncodeErr, setHsncodeErr] = React.useState("");
  const [priceErr, setPriceErr] = React.useState("");
  const [gstErr, setGstErr] = React.useState("");
  const [simpleSelect, setSimpleSelect] = React.useState("");
  const [simpleSelectErr, setSimpleSelectErr] = React.useState("");
  const [active, setActive] = React.useState(false);

  const [newPacking, setNewPacking] = React.useState(false);

  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [btn, setBtn] = React.useState(false);

  const classes = useStyles();
  const classe = useStyle();
  const classSweet = useStyleSweet();

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const handleSimple = (event) => {
    setSimpleSelect(event.target.value);
    setSimpleSelectErr("");
  };

  const SubmitAddPacking = () => {
    setNewPacking(true);
    let errorCount = 0;
    if (simpleSelect === "" || !simpleSelect) {
      errorCount++;
      setSimpleSelectErr("Select Packing Type");
    }
    if (dibbiName === "" || !dibbiName) {
      errorCount++;
      setDibbiErr("Material Name is Required");
    }
    if (hsncode === "" || !hsncode) {
      errorCount++;
      setHsncodeErr("HSN Code is Required");
    }

    if (price === "" || !price) {
      errorCount++;
      setPriceErr("Price is Required");
    }

    if (gst === "" || !gst) {
      errorCount++;
      setGstErr("GST is Required");
    }

    if (errorCount === 0) {
      setBtn(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          type: simpleSelect,
          pkgdesc: dibbiName,
          hsncode: hsncode,
          price: price,
          ligst: gst,
        }),
      };

      fetch(
        localApi + `/packingmaterial/add/byAdminId/${userObj.id}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          if (data.message === "Data Inserted Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          }
        });
    }
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  return (
    <div>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <AddIcon />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Add Packing Material</small>
                {newPacking === true ? (
                  <small
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    {simpleSelectErr ||
                      dibbiErr ||
                      hsncodeErr ||
                      priceErr ||
                      gstErr}
                  </small>
                ) : (
                  <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                    Select Packing Type
                  </small>
                )}
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                {submitted ? (
                  <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  >Added Packing Material</SweetAlert>
                ) : null}{" "}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classe.selectFormControl}>
                    <InputLabel
                      htmlFor="simple-select"
                      className={classe.selectLabel}
                    >
                      Select Packing Type...
                    </InputLabel>

                    <Select
                      MenuProps={{
                        className: classe.selectMenu,
                      }}
                      classes={{
                        select: classe.select,
                      }}
                      value={simpleSelect}
                      onChange={handleSimple}
                      inputProps={{
                        name: "simpleSelect",
                        id: "simple-select",
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classe.selectMenuItem,
                        }}
                      >
                        Select Packing Type...
                      </MenuItem>

                      <MenuItem
                        classes={{
                          root: classe.selectMenuItem,
                          selected: classe.selectMenuItemSelected,
                        }}
                        value="Crystal Dibbi"
                      >
                        Crystal Dibbi
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classe.selectMenuItem,
                          selected: classe.selectMenuItemSelected,
                        }}
                        value="Plastic Dibbi"
                      >
                        Plastic Dibbi
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classe.selectMenuItem,
                          selected: classe.selectMenuItemSelected,
                        }}
                        value="Polythene PP"
                      >
                        Polythene PP
                      </MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Material Name..."
                    id="dibbiName"
                    inputProps={{
                      placeholder: "Ex. 2 pcs...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="dibbiName"
                    value={dibbiName}
                    onChange={(e) => {
                      setDibbiName(e.target.value);
                      setDibbiErr("");
                    }}
                    required={true}
                  />
                  {/* <span style={{ color: "red" }}>{dibbiErr}</span> */}
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="HSN Code..."
                    id="hsncode"
                    inputProps={{
                      placeholder: "Ex. 39202020...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="hsncode"
                    value={hsncode}
                    onChange={(e) => {
                      setHsncode(e.target.value);
                      setHsncodeErr("");
                    }}
                    required={true}
                  />
                  {/* <span style={{ color: "red" }}>{hsncodeErr}</span> */}
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Price..."
                    id="price"
                    inputProps={{
                      placeholder: "Ex. 0.75...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="price"
                    value={price}
                    onChange={(e) => {
                      setPrice(e.target.value);
                      setPriceErr("");
                    }}
                    required={true}
                  />
                  {/* <span style={{ color: "red" }}>{priceErr}</span> */}
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="GST @18%..."
                    id="gst"
                    inputProps={{
                      placeholder: "Ex. 18...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="gst"
                    value={gst}
                    onChange={(e) => {
                      setGst(e.target.value);
                      setGstErr("");
                    }}
                    required={true}
                  />
                  {/* <span style={{ color: "red" }}>{gstErr}</span> */}
                </GridItem>
              </GridContainer>
              {/* <Button
                color="rose"
                onClick={SubmitAddPacking}
                className={classes.updateProfileButton}
              >
                Save
              </Button> */}
              {btn === true ? (
                <Button className={classes.updateProfileButton}>Save</Button>
              ) : (
                <Button
                  color="rose"
                  onClick={SubmitAddPacking}
                  className={classes.updateProfileButton}
                >
                  Save
                </Button>
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
